import { render, staticRenderFns } from "./GGCardHeader.vue?vue&type=template&id=2dd10800&"
import script from "./GGCardHeader.vue?vue&type=script&lang=js&"
export * from "./GGCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dd10800')) {
      api.createRecord('2dd10800', component.options)
    } else {
      api.reload('2dd10800', component.options)
    }
    module.hot.accept("./GGCardHeader.vue?vue&type=template&id=2dd10800&", function () {
      api.rerender('2dd10800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/Card/GGCardHeader.vue"
export default component.exports